import { Link } from 'react-router-dom';

export const routerLinkWithProps = linkProps => ({
  component: Link,
  ...linkProps,
});
